import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";

export const sentimentVerySatisfied = (props) => {
  return <SentimentVerySatisfiedIcon {...props} />;
};
